import stringToNumber from "src/utils/stringToNumber";
import * as yup from "yup";

const addAndChangeSchema = (translate: Function,language:string) => yup.object().shape({
	taa006Titulo: yup.string().required(translate("O titulo da métrica é requerido")),
	taa006Situacao: yup.boolean(),
	tatba007: yup.array().of(Targets(translate,language)).min(1,translate("Ao menos uma faixa deve ser informada"))
});

const Targets = (translate: Function,language:string) => yup.object().shape({
	taa007Cor: yup.string().required(translate("Cor da faixa é requerida")),
	taa007Valorini: yup.number()
		.transform((value,originalValue) => typeof originalValue !== "string" ? value : stringToNumber(originalValue,language))
		.required(translate("Valor inicial a faixa é requerida"))
		.typeError(translate("Valor inicial está incorreto")),
	taa007Valorfim:yup.number()
		.transform((value,originalValue) => typeof originalValue !== "string" ? value : stringToNumber(originalValue,language))
		.required(translate("Valor final da faixa é requerida"))
		.typeError(translate("Valor final está incorreto"))
		.when("taa007Valorini",(initiaValue,schema) => initiaValue ? schema.min(initiaValue,translate("Valor inicial não pode ser menor que o final")):schema)
});

export default  addAndChangeSchema;
